import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { Link } from 'react-router-dom'

import config from 'config'
import styles from './award-toggle.styl'

export default class AwardToggle extends Component {
  static propTypes = {
    awardsList: PropTypes.array,
    awardId: PropTypes.number
  }

  render() {
    const { awardsList, awardId } = this.props

    return (
      <ul className={styles.list}>
        {awardsList.map(item => (
          <li
            key={item.id}
            className={`${styles.item} ${awardId === item.id ? styles.active : ''}`}
          >
            <Link className={styles.link} to={`${config.publicPath}/dashboard/awards/${item.id}`}>
              {get(item, 'awardLevel.translationText')}
            </Link>

          </li>
        ))}
      </ul>
    )
  }
}
